import Script from 'next/script';
import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import { twMerge } from 'tailwind-merge';

const INSTAGRAM_EMBED_URL = 'https://www.instagram.com/embed.js';

const buildInstagramUrl = (contentType, id) =>
  `https://www.instagram.com/${contentType}/${id}/`;

const sanitizeUrl = (inputUrl) => {
  try {
    const parsedUrl = new URL(inputUrl);
    const path = parsedUrl.pathname.split('/').filter(Boolean);

    const reelIndex = path.findIndex((p) => p === 'reel' || p === 'reels');
    if (reelIndex !== -1 && path[reelIndex + 1]) {
      return buildInstagramUrl('reel', path[reelIndex + 1]);
    }
    const postIndex = path.findIndex((p) => p === 'p');
    if (postIndex !== -1 && path[postIndex + 1]) {
      return buildInstagramUrl('p', path[postIndex + 1]);
    }
    const igtvIndex = path.findIndex((p) => p === 'tv');
    if (igtvIndex !== -1 && path[igtvIndex + 1]) {
      return buildInstagramUrl('tv', path[igtvIndex + 1]);
    }
    if (path[0] === 'stories' && path.length >= 3) {
      const profile = path[1];
      const id = path[2];
      return buildInstagramUrl(`stories/${profile}`, id);
    }

    return inputUrl;
  } catch {
    return inputUrl;
  }
};

const InstagramEmbed = ({ className, url }) => {
  const containerRef = useRef(null);
  const normalizedUrl = sanitizeUrl(url);

  useEffect(() => {
    window.instgrm?.Embeds.process();
  }, [normalizedUrl]);

  return (
    <>
      <Script
        src={INSTAGRAM_EMBED_URL}
        strategy="lazyOnload"
        onLoad={() => {
          window.instgrm?.Embeds.process();
        }}
      />
      <blockquote
        ref={containerRef}
        className={twMerge(
          'instagram-media mx-auto h-[614px] w-14 max-w-14 overflow-hidden rounded-5',
          className
        )}
        data-instgrm-permalink={normalizedUrl}
      />
    </>
  );
};

InstagramEmbed.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  url: PropTypes.string.isRequired,
};

export default InstagramEmbed;
